@if(externArbetsorderDetails$ | async; as externArbetsorderDetails){
@if (externArbetsorderDetails.viol3) {
<rask-extern-arbetsorder-details-viol3></rask-extern-arbetsorder-details-viol3>
}
@else {
<rask-extern-arbetsorder-details-viol2></rask-extern-arbetsorder-details-viol2>
}
}